import type { FilterOptionViewModel } from 'autogen/swagger/all';
import Flex from 'components/Layout/components/Flex';
import React from 'react';
import { Typography } from 'components/generic/typography';
import { useTranslation } from 'react-i18next';
import { ProductPageSizeText } from 'autogen/translation-keys/trans-website-filter';
import PageSizeOptionsRenderer from './components/PageSizeOptionsRenderer';

export default function PageSize({ model: pageSizes }: { model: FilterOptionViewModel[] }) {
    const { t } = useTranslation();

    if (!pageSizes.length) return null;

    return (
        <Flex.Row justifyContent="center">
            <Typography.Body as="span" size="S">
                {t(ProductPageSizeText)}:
            </Typography.Body>
            <PageSizeOptionsRenderer model={pageSizes} />
        </Flex.Row>
    );
}
